/** A backend without `hasImage` lists nobody, so every child keeps their photo */
export const transformChildIdsWithoutImage = (children) => children.filter(({ child }) => child.hasImage === false).map(({ child }) => child.childId);
